import React, { useEffect } from "react";
import MiniHero from "./../MiniHero";

function OurTeam({ homeRef, handleScroll }) {
  useEffect(() => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  }, []);
  return (
    <>
      <MiniHero
        homeRef={homeRef}
        onScroll={handleScroll}
        title="About Us"
        className="fs-48 text-dark mb-5"
      />
      <div className="container pt-1 pb-5">
        <div className="max-width-640 mx-auto">
          <p>
            Tanaad is an online money transfer service that makes sending money
            easy from UK to Africa and Middle East. We have selectively sourced
            our pay-out partners to cut down the cost of sending money and
            regularly update our FX rates to enable us pass best rates to our
            customers.
          </p>
          <p>
            Our head office is in Hounslow-Greater London that serves the
            marketing, compliance and customer support offices. Apart from the
            cost advantage, we deliver best customer experience.
          </p>
          <p>
            Our system is supported by GBGPLC platform, a robust compliance
            platform with fully integrated PEPS,KYC and AML features.
          </p>
        </div>
      </div>
    </>
  );
}

export default OurTeam;
